
import { FC} from 'react';
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import { obtenerIcono } from './../util/AppIcons';
import useWindowDimensions from './../util/windows-dimension-hooks';
import { LayoutSize } from '../util/LayoutSize';
import { IPreHeader } from '../../model/IPreHeader';

export const PreHeader: FC<{preHeader:IPreHeader}> = (props) => {

    const _style:React.CSSProperties = {
        display: "block",
        transition: "",
        opacity: ""
    }

    return (
        <>
            {
                useWindowDimensions().width >= LayoutSize.l ?

                    <div id="pre-header-div" style={{ ..._style, backgroundColor: "black", height: "34px" }}>
                        <div style={{ paddingLeft: "40px", paddingTop: "5px" }}>
                            <Row justify='space-between'>
                                <Col >

                                    {
                                        props.preHeader?.desktop?.map((_, index) =>
                                            <label key={index} id={`preheader_label_${_.text}`} className='label-pre-header' style={{ color: "white", marginRight: "20px" }}>
                                                <Link style={{ color: "white" }} to={_.link}>{_.text}</Link>
                                            </label>
                                        )
                                    }
                                </Col>

                                <Col style={{ display: "flex", alignItems: "center"}}>
                                    {
                                        props.preHeader?.icon?.map((_, index) =>
                                            <label key={index} className='label-pre-header' id={`preheader_icon_${_.id}`} style={{ color: "white", marginRight: "20px" }}>
                                                <a rel="noreferrer" target="_blank" style={{ color: "white" }} href={_.link}>{obtenerIcono(_.icon)}</a>
                                            </label>
                                        )
                                    }

                                </Col>
                            </Row>


                          


                        </div>
                    </div>


                    :
                    <></>

            }

        </>

    )
}